// extracted by mini-css-extract-plugin
export default {"container":"CopyTextToClipboard_container__2VAiE","icon":"CopyTextToClipboard_icon__rmgyH","skeletonLoadingAnimation":"CopyTextToClipboard_skeletonLoadingAnimation__HJPhH"};